import * as actionTypes from "../../actions/actionTypes";
import {updateObject} from "../../shared/utility";
import UtilService from "../../../helper/service";
import {IExperienceManager} from "../../../interface/iExperience";

const initialState: IExperienceManager = {
  sessionData: null,
  participantsCode: [],
  immersionData: [],
  safetyData: [],
  graphType: 0,
  filter: true,
  managerLoading: false,
  code_loading: false,
  code_loaded: false,
  markers: [],
  agendas: [],
  stimulusList: [],
  start: false,
  time: '00:00:00',
  requestInterval: 0,
  timeInterval: 0,
  activeParticipants: [],
  from_epoch: 0,
  to_epoch: 0,
  immersion: null,
  satefydata: null,
  specialProjectId: -1,
  clipData: null,
  audienceImmersions: [],
  audienceSafes: [],
  agendaImmersions: [],
  agendaSafes: [],
  highlights: null,
  highestSegments: [],
  lowestSegments: [],
  thumbnailUploaded: false,
  uploadedThumbnail: [],
  overviewAgendas: [],
  identifiers: [],
  immersionIndex: null,
  safetyIndex: null,
  overviewMarkers: [],
  sessionOverview: [],
  tagApplied: false,
  fetching: false,
  fullLoaded: false,
  freeText: '',
  overviewLoadingTime: -1,
  managerHubList: [],
  managerSelectedHubs: [],
  categories: null,
  projectID: -1,
  tempProject: false
};

const reducer = (state = { ...initialState }, action: any) => {
  switch (action.type) {

    case actionTypes.SET_MANAGER_LOADING:
      return updateObject(state, {
        managerLoading: action.payload
      });

    case actionTypes.UPDATE_FETCHING:
      return updateObject(state, {
        fetching: action.payload
      });

    case actionTypes.SET_CODE_LOADING:
      return updateObject(state, {
        code_loading: action.payload
      });

    case actionTypes.SET_FILTER:
      return updateObject(state, {
        filter: action.payload
      });

    case actionTypes.UPDATE_SESSION_DATA:
      return updateObject(state, {
        sessionData: action.payload
      });

    case actionTypes.UPDATE_IMMERSION_INDEX:
      return updateObject(state, {
        immersionIndex: action.payload
      });

    case actionTypes.UPDATE_SAFETY_INDEX:
      return updateObject(state, {
        safetyIndex: action.payload
      });

    case actionTypes.UPDATE_FULL_LOADED_OVERVIEW:
      return updateObject(state, {
        fullLoaded: action.payload
      });
      
    case actionTypes.GET_PARTICIPANTS_CODE_SUCCESS:
      const codes: string[] = [];
      action.payload.forEach((item: any) => {
        if (item.identifier) {
          codes.push(item.identifier);
        }
      });
      return updateObject(state, {
        participantsCode: codes,
        code_loaded: true
      });

    case actionTypes.EXPERIENCE_CATEGORIES_SUCCESS:
      return updateObject(state, {
        categories: action.payload,
      });

    case actionTypes.GET_GRAPH_DATA_SUCCESS:

      const currentImmersionData = [...state.immersionData];
      const currentSafetyData = [...state.safetyData];
      const currentActiveParticipants = [...state.activeParticipants];
      const newImmersionData: any = {};
      const newSafetyData: any = {};

      newImmersionData[action.payload.activeParticipant] = action.payload.immersion;
      newSafetyData[action.payload.activeParticipant] = action.payload.safety;

      if (action.payload.activeParticipant === 'All') {
        currentImmersionData.unshift(newImmersionData);
        currentSafetyData.unshift(newSafetyData);
        currentActiveParticipants.unshift(action.payload.activeParticipant);
      } else {
        currentImmersionData.push(newImmersionData);
        currentSafetyData.push(newSafetyData);
        currentActiveParticipants.push(action.payload.activeParticipant);
      }
      return updateObject(state, {
        immersionData: currentImmersionData,
        safetyData: currentSafetyData,
        activeParticipants: currentActiveParticipants
      });

    case actionTypes.REMOVE_PARTICIPANT_GRAPH_DATA:

      const dataImmersion = [...state.immersionData];
      const dataSafety = [...state.safetyData];
      const participants = [...state.activeParticipants];
      const updatedImmersionData = dataImmersion.filter((item) => Object.keys(item)[0] !== action.payload);
      const updatedSafetyData = dataSafety.filter((item) => Object.keys(item)[0] !== action.payload);
      const updatedParticipants = participants.filter(item => item !== action.payload);

      return updateObject(state, {
        immersionData: updatedImmersionData,
        safetyData: updatedSafetyData,
        activeParticipants: updatedParticipants
      });

    case actionTypes.INIT_LIVE_ANALYSIS_DATA:
      return updateObject(state, {
        ...initialState
      });

    case actionTypes.CHANGE_GRAPH_TYPE:
      return updateObject(state, {
        graphType: action.payload
      });

    case actionTypes.GET_STIMULUS_INFO_SUCCESS:
      return updateObject(state, {
        stimulusList: action.payload
      });

    case actionTypes.SET_START:
      return updateObject(state, {
        start: action.payload
      });

    case actionTypes.GET_GRAPH_DATA_START_BTN_SUCCESS:

      // Immersion Update
      const immersionDataCurrent = [...state.immersionData];
      const indexImmersion = immersionDataCurrent.findIndex((item, ) => {
        if (Object.keys(item)[0] === action.payload.activeParticipant) {
          return true;
        } else {
          return -1;
        }
      });
      const newImmersionItem: any = {};
      newImmersionItem[action.payload.activeParticipant] = action.payload.data;
      immersionDataCurrent.splice(indexImmersion, 1);
      immersionDataCurrent.splice(indexImmersion, 0, newImmersionItem);

      // Safety Update
      const safetyDataCurrent = [...state.safetyData];
      const indexSafety = safetyDataCurrent.findIndex((item, ) => {
        if (Object.keys(item)[0] === action.payload.activeParticipant) {
          return true;
        } else {
          return -1;
        }
      });
      const newSafetyItem: any = {};
      newSafetyItem[action.payload.activeParticipant] = action.payload.data;
      safetyDataCurrent.splice(indexSafety, 1);
      safetyDataCurrent.splice(indexSafety, 0, newSafetyItem);

      // Return Value
      return updateObject(state, {
        immersionData: immersionDataCurrent,
        safetyData: safetyDataCurrent
      });

    case actionTypes.UPDATE_TIME:
      return updateObject(state, {
        time: action.payload
      });

    case actionTypes.UPDATE_REQUEST_INTERVAL:
      return updateObject(state, {
        requestInterval: action.payload
      });

    case actionTypes.UPDATE_TIME_INTERVAL:
      return updateObject(state, {
        timeInterval: action.payload
      });

    case actionTypes.START_EPOCH:
      const to_epoch = UtilService.getNowUTCTime();
      const from_epoch = UtilService.getXMinsBehindTime(to_epoch, 10);
      return updateObject(state, {
        from_epoch,
        to_epoch
      });

    case actionTypes.UPDATE_IMMERSION_DATA:
      return updateObject(state, {
        immersion: action.payload
      });

    case actionTypes.UPDATE_SAFETY_DATA:
      return updateObject(state, {
        safetydata: action.payload
      });

    case actionTypes.REMOVE_MARKER_DATA:

      const filteredMarkers = state.markers.filter(item => item.id !== action.payload)

      return updateObject(state, {
        markers: [...filteredMarkers]
      });

    // case actionTypes.UPDATE_MARKER_TIME:
    //   return null
    // const newMarkers2 = [...state.markers];
    // const myIndex2 = state.markers.findIndex(item => item.id === action.payload.id)

    // newMarkers2[myIndex2].end = state.markers[myIndex2].end + action.payload.value;

    // return updateObject(state, {
    //   markers: [...newMarkers2]
    // });
    case actionTypes.UPDATE_SPECIAL_PROJECT:
      return updateObject(state, {
        specialProjectId: action.payload
      })



    case actionTypes.UPDATE_AUDIENCE_IMMERSIONS:
      return updateObject(state, {
        audienceImmersions: action.payload
      });

    case actionTypes.UPDATE_AUDIENCE_SAFES:
      return updateObject(state, {
        audienceSafes: action.payload
      });

    case actionTypes.UPDATE_AGENDA_IMMERSIONS:
      return updateObject(state, {
        agendaImmersions: action.payload
      });

    case actionTypes.UPDATE_AGENDA_SAFES:
      return updateObject(state, {
        agendaSafes: action.payload
      });

    case actionTypes.UPDATE_HIGHLIGHTS:
      const t = action.payload;
      const data = {
        worst_moments: null,
        best_moments: null,
      };
      t.worst_moments && (data.worst_moments = t.worst_moments);
      t.best_moments && (data.best_moments = t.best_moments);
      return updateObject(state, {
        highlights: data
      });

    case actionTypes.UPDATE_HIGHEST_SEGMENTS:
      return updateObject(state, {
        highestSegments: action.payload
      });

    case actionTypes.UPDATE_LOWEST_SEGMENTS:
      return updateObject(state, {
        lowestSegments: action.payload
      });

    case actionTypes.UPDATE_THUMBNAIL:
      return updateObject(state, {
        uploadedThumbnail: action.payload,
        thumbnailUploaded: true
      });

    case actionTypes.INIT_THUMBNAIL_UPLOADED:
      return updateObject(state, {
        thumbnailUploaded: false
      });

    case actionTypes.UPDATE_OVERVIEW_AGENDAS:
      const agendas = [...action.payload];
      const agendaList = agendas.filter((agenda) => agenda['marker_type'] === 1 && agenda['deleted'] === false);
      const markers = agendaList.map((item) => {
        return { 'start': Number(item['start_marker_at']), 'end': Number(item['end_marker_at']) }
      });
      return updateObject(state, {
        overviewAgendas: agendaList,
        overviewMarkers: markers
      });

    case actionTypes.UPDATE_IDENTIFIERS:
      const identifiers = [...action.payload];
      const filterList = identifiers.filter((item) => item['identifier'] !== null);
      return updateObject(state, {
        identifiers: filterList.map((item) => item['identifier'])
      });

    case actionTypes.SESSION_OVERVIEW:
      return updateObject(state, {
        sessionOverview: action.payload
      });

    case actionTypes.TAG_APPLIED:
      return updateObject(state, {
        tagApplied: action.payload
      });

    case actionTypes.UPDATE_FREE_TEXT:
      return updateObject(state, {
        freeText: action.payload
      });

    case actionTypes.PROJECT_ID_UPDATE:
      return updateObject(state, {
        project_folder_id: action.payload,
      });

    case actionTypes.SET_PROJECT_ID:
      return updateObject(state, {
        projectID: action.payload,
      });

    case actionTypes.SET_TEMP_PROJECT:
      return updateObject(state, {
        tempProject: action.payload,
      });

    case actionTypes.CALCULATE_OVERVIEW_TIME:        
      return updateObject(state, {
        overviewLoadingTime: action.payload,
      });

    case actionTypes.GET_MANAGE_HUBS_SUCCESS:
      return updateObject(state, {
        managerHubList: action.payload
      });

    case actionTypes.UPDATE_SELECTED_HUBS:
      return updateObject(state, {
        managerSelectedHubs: action.payload
      });
      
    default:
      return state;
  }
};

export default reducer;

